import { CustomEventWithDetail } from 'rune-ts';

export class EditorInputFocusoutEvent extends CustomEventWithDetail<{ name: string; index?: number }> {}
